import { dataSourceAtom } from "@/atoms/app";
import { getSearchParam } from "@/utils";

export default function TestTips1() {
  const dataSource = useAtomValue(dataSourceAtom);
  const test_data_source = getSearchParam("test_data_source") || "";
  return test_data_source + "" === "1" && <p className="color-red text-20">数据来源：{dataSource}</p>;
}
